var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('app-main'),_c('footer-bar'),_c('reset-session-modal',{attrs:{"isActive":_vm.sessionModalActive,"title":"Continue Application Session?","remaining":_vm.modalTimeRemaining},on:{"close":function($event){return _vm.closeModal()},"logoutAndClose":function($event){return _vm.logoutAndCloseModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }